import React, { useState } from 'react';
import { Upload, X } from "lucide-react";
import { useEffect } from 'react';

const ImageUploadEvent = ({
  previewImages,
  handleFiles,
  removeImage,
  selectedImages,
  uploadedImges = [],
  setExistImages
}: any) => {
  const [uploadedImagesState, setUploadedImagesState] = useState();
  const totalImages = previewImages?.length + uploadedImagesState?.length;
  const canUploadMore = totalImages < 5;
   const removeUploadedImage = (index: number) => {
    setUploadedImagesState((prev: any) => {
      const updated = prev.filter((_: any, i: number) => i !== index)
      setExistImages(updated)
      return updated;
    });
  };

  useEffect(() => {
    setUploadedImagesState(uploadedImges);
      setExistImages(uploadedImges)
  }, [uploadedImges]);
  
  return (
    <div>
      {totalImages === 0 ? (
        <div className="w-full flex flex-col justify-center items-center ">
          <Upload size={50} className="text-[#1a3b5d]" />

          <p className="text-[#1a3b5d] font-semibold">Drag & Drop or Browse</p>

          <input
            type="file"
            multiple
            id="fileInput"
            className="hidden"
            accept="image/*"
            onChange={(e) => handleFiles(e.target.files)}
            disabled={!canUploadMore}
          />

          <label
            htmlFor="fileInput"
            className={`cursor-pointer underline ${canUploadMore ? "text-blue-600" : "text-gray-400 cursor-not-allowed"
              }`}
          >
            Browse Files
          </label>
        </div>
      ) : (
        <div className="flex space-x-4 ">

          <div className="space-x-4 flex overflow-x-auto">

            {/* ------------------ SHOW EXISTING UPLOADED IMAGES ------------------ */}
            {uploadedImagesState?.map((url: string, index: number) => (
              <div key={`uploaded-${index}`} className="relative group w-28 h-24 rounded-md overflow-hidden">
                <img src={url} className="w-full h-full object-cover" />

                <button
                  type="button"
                  onClick={() => removeUploadedImage(index)}
                  className="absolute top-1 right-1 bg-red-600 text-white p-1 rounded-full opacity-0 
                          group-hover:opacity-100 transition"
                >
                  <X size={12} />
                </button>
              </div>
            ))}

            {/* ------------------ SHOW PREVIEW IMAGES (AS-IS) ------------------ */}
            {previewImages?.map((url: any, index: any) => (
              <div key={`preview-${index}`} className="relative group w-28 h-24 rounded-md overflow-hidden">
                <img src={url} className="w-full h-full object-cover" />

                <button
                  type="button"
                  onClick={() => removeImage(index)}
                  className="absolute top-1 right-1 bg-red-600 text-white p-1 rounded-full opacity-0 
                          group-hover:opacity-100 transition"
                >
                  <X size={12} />
                </button>
              </div>
            ))}

          </div>

          {/* ------------------ ADD MORE SECTION ------------------ */}
          {canUploadMore && (
            <div>
              <div
                onClick={() => document.getElementById("addMore")?.click()}
                className=" flex items-center justify-center border-2 border-dashed h-24 w-28 cursor-pointer"
              >
                <span className="text-3xl text-gray-400">+</span>

                <input
                  id="addMore"
                  type="file"
                  multiple
                  className="hidden"
                  accept="image/*"
                  onChange={(e) => handleFiles(e.target.files)}
                />
              </div>

              <p className="text-center mt-1 text-xs">
                {totalImages} selected (max 5)
              </p>
            </div>
          )}

        </div>
      )}
    </div>
  );
};

export default ImageUploadEvent;
